// extracted by mini-css-extract-plugin
export default {"link":"jL-z","disabled":"kL-z"};